var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.36842 0 0 5.36842 0 12C0 18.6316 5.36842 24 12 24C18.6316 24 24 18.6316 24 12C24 5.36842 18.6316 0 12 0Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2309 9.91574V12H7.26245V15.1578H10.2309V23.8105C10.7993 23.9368 11.3677 24 11.9993 24C12.5677 24 13.073 23.9368 13.6414 23.8736V15.1578H16.7361L17.2414 12H13.6414V10.2947C13.6414 8.96837 14.0835 7.83153 15.2835 7.83153H17.2414V5.05259C16.9256 4.98943 16.1677 4.92627 14.7782 4.92627C11.873 4.92627 10.2309 6.44206 10.2309 9.91574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.40da2564ebf4ee8588002b43f5734153.svg";
export { ForwardRef as ReactComponent };